<template>
	<div class="answer-radio position-rel">
		<input :name="nameField" type="radio" :value="dataSource.content ? dataSource.content : dataSource.imageUrl" :checked="(dataSource.answerContent && dataSource.err) || (dataSource.answerContent && dataSource.saved)" @change="changeAnswer($event, {location, type: parent.type, questionId: dataSource.questionId})">
		<label class="display-flex-center">
			<b v-if="dataSource.code">{{ dataSource.code }} </b>
			<span v-html="dataSource.content"></span>
		</label>
	</div>
</template>

<script>
	import mixinsQuestionPreview from './../../_store/mixinsQuestionPreview'

	export default {
		name: 'MultipleChoice',
		mixins: [ mixinsQuestionPreview ],
		data () {
			return {
			}
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
</style>